import { createContext, useReducer, useState, useContext } from 'react'

export const FirstServerIPsContext = createContext() 

export const firstServerIPsReducer = (state, action) => {
    switch (action.type) {
        case 'SET_FIRSTSERVERIPS':
            return { firstServersIPs: action.payload }
        case 'CREATE_FIRSTSERVERIPS':
            return { firstServersIPs: [action.payload, ...state.firstServersIPs] }
        case 'UPDATE_FIRSTSERVERIPS':
            return { firstServersIPs: action.payload }
        case 'DELETE_FIRSTSERVERIPS':
            return { firstServersIPs: action.payload }
        case 'SET_SERVERINFOS':
            return { serverInfos: action.payload }
        default:
            return state
    }
}

export const FirstServerIPsContextProvider = ({children}) => {
    const [state, dispatch] = useReducer(firstServerIPsReducer, { firstServersIPs: [] })
    const [targetFirstServerIPs, setTargetFirstServerIPs] = useState(null)
    return (
      <FirstServerIPsContext.Provider 
        value={{ ...state, dispatch, targetFirstServerIPs: targetFirstServerIPs, setTargetFirstServerIPs: setTargetFirstServerIPs}}>
          { children }
      </FirstServerIPsContext.Provider>
    )
}

export const useFirstServerIPsContext = () => {
    const context = useContext(FirstServerIPsContext)
    if(!context) throw Error('useFirstServerIPsContext must be used inside an FirstServerIPsContextProvider')
    return context
}